/* globals $ Craft App */

export default class ProviderInvitation {
  constructor($elem) {
    this.$elem = $elem;
    this.$tokenForm = $elem.find(".js-token-form");
    this.$form = $elem.find(".js-form");
    this.$error = $elem.find(".js-error");
    this.$errorMessage = $elem.find(".js-error-message");
    this.$provider = $elem.find(".js-provider");
    this.$form.find(".freeform-form")[0].addEventListener("freeform-ajax-error", () => {
      $("html, body").animate({ scrollTop: this.$form.offset().top }, "slow");
    });
    this.$form.find("input[name='lang']").val(Craft.currentSite.lang.slice(0, 2));
    this.init();
  }

  init() {
    this.$tokenForm.on("submit", (e) => {
      e.preventDefault();
      if (this.$tokenForm.find("input[name='token']").val().length < 14) {
        this.$errorMessage.html(this.$tokenForm.data("invalid-token-message"));
        this.$errorMessage.removeClass("hidden");
        return;
      }
      this.reset();
      App.forms.getCaptchaToken("invitationToken").then((token) => {
        this.$tokenForm.find("input[name='captchaToken']").val(token);
        App.forms.disableSubmit(this.$tokenForm.find("button[type='submit']"));
        $.ajax({
          method: "post",
          url: Craft.currentSite.baseUrl,
          data: this.$tokenForm.serialize(),
          headers: {
            "X-CSRF-Token": Craft.csrfToken,
          },
        })
          .fail((e) => {
            if (e.responseJSON && e.responseJSON.message) {
              this.$errorMessage.html(e.responseJSON.message);
              this.$errorMessage.removeClass("hidden");
            } else {
              this.$error.removeClass("hidden");
            }
          })
          .done((response) => {
            this.$tokenForm.addClass("hidden");
            this.populateProvider(response.data.provider);
            this.$form.removeClass("hidden");
            this.$form.find("input[name='apiToken']").val(this.$tokenForm.find("input[name='token']").val());
          })
          .always(() => {
            App.forms.enableSubmit(this.$tokenForm.find("button[type='submit']"));
          });
      });
    });
    let $input = this.$tokenForm.find("input[name='token']");
    $input.on("paste", () => {
      setTimeout(() => {
        $input.val(this.formatCode($input.val()));
      }, 100);
    });
    $input.on("keydown", (e) => {
      let code = e.originalEvent.keyCode;
      // Allow backspace, enter, shift
      if ((code >= 65 && code <= 90) || (code >= 48 && code <= 57) || code == 173) {
        e.preventDefault();
        $input.val(this.formatCode($input.val() + e.originalEvent.key));
        return;
      }
    });
  }

  formatCode(code) {
    if (!code) {
      return "";
    }
    code = code.toUpperCase().replace(/[^A-Z0-9]/g, "");
    let segments = Array.from({ length: Math.ceil(code.length / 4) }, (v, i) => code.slice(i * 4, i * 4 + 4));
    segments = segments.splice(0, 3);
    if (segments.length && segments[segments.length - 1].length === 4 && segments.length < 3) {
      segments[segments.length - 1] += "-";
    }
    return segments.join("-");
  }

  populateProvider(provider) {
    this.$provider.find(".js-firstName").html(provider.firstName);
    this.$provider.find(".js-lastName").html(provider.lastName);
    this.$provider.find(".js-gender").html(provider.gender == "male" ? "M" : "F");
    this.$provider.find(".js-yearOfBirth").html(provider.yearOfBirth);
    this.$provider.removeClass("hidden");
  }

  reset() {
    this.$form.addClass("hidden");
    this.$provider.addClass("hidden");
    this.$errorMessage.addClass("hidden");
    this.$error.addClass("hidden");
  }
}
